import React, { useState } from 'react';
import ImagePicker from '../../components/inputFields/ImagePicker';
import { Form, Formik } from 'formik';
import * as Yup from "yup";
import InputField from '../../components/inputFields/InputField';
import Button from '../../components/buttons/Button';
import { sanitizeMobile } from '../../utils/phone';

function StoreDetailsView() {
    // State variables to manage selected images
    const [isEditing, setEditing] = useState(false);
    const [storeImage, setStoreImage] = useState(null);
    const [images, setImages] = useState([{ id: Date.now(), file: null }]);

    // Function to handle adding a new image slot
    const handleAddImage = () => {
        setImages([...images, { id: Date.now(), file: null }]);
    };

    // Function to handle selecting an image
    const handleImageSelect = (id, file) => {
        setImages(images.map((img) => (img.id === id ? { ...img, file } : img)));
    };

    const handleStoreImage = (file) => {
        setStoreImage(file);
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
    };

    const handleEditing = (value) => {
        setEditing(value);
    };

    return (
        <Formik
            initialValues={{
                shop_name: "",
                phone_number_1: "",
                owner_contact: "",
                whatsapp_number: "",
                shop_email: "",
            }}
            validationSchema={Yup.object({
                shop_name: Yup.string().required("Please enter your Name"),
                phone_number_1: Yup.string().required("Please enter your Email"),
                owner_contact: Yup.string().required("Please enter your Phone Number"),
                whatsapp_number: Yup.string().required("Please Provide Whatsapp"),
                shop_email: Yup.string().required("Please Provide Email"),
            })}
            onSubmit={handleFormSubmit}
        >
            {({ isSubmitting, setFieldValue }) => (
                <Form>
                    <div className="flex flex-row gap-4">
                        <div className="flex flex-col lg:flex-row gap-4">
                            <div className="w-48 h-48">
                                <ImagePicker
                                    preloadedImage={storeImage}
                                    placeholder={"Upload Store Logo"}
                                    onImageSelect={handleStoreImage}
                                    disabled={!isEditing}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col xl:flex-row gap-4">
                            <div className="flex flex-col max-w-80 flex-1">
                                <InputField
                                    label="Shop Name"
                                    name="shop_name"
                                    type="text"
                                    placeholder="Enter Shop Name"
                                    disable={!isEditing}
                                    required
                                />
                                <div className="flex flex-row gap-2">
                                    <InputField
                                        label="Phone Number 1"
                                        name="phone_number_1"
                                        type="text"
                                        placeholder="Enter Primary Phone"
                                        disable={!isEditing}
                                        required

                                        onChange={(e) => setFieldValue('phone_number_1', sanitizeMobile(e.target.value))}
                                    />
                                    <InputField
                                        label="Phone Number 2"
                                        name="phone_number_2"
                                        type="text"
                                        placeholder="Enter Secondary Phone"
                                        disable={!isEditing}

                                        onChange={(e) => setFieldValue('phone_number_2', sanitizeMobile(e.target.value))}
                                    />
                                </div>
                                <div className="flex flex-row gap-2">
                                    <InputField
                                        label="Whatsapp No."
                                        name="whatsapp_number"
                                        type="text"
                                        placeholder="Enter your Whatsapp Number"
                                        disable={!isEditing}
                                        required

                                        onChange={(e) => setFieldValue('whatsapp_number', sanitizeMobile(e.target.value))}
                                    />
                                    <InputField
                                        label="Shop Email"
                                        name="shop_email"
                                        type="text"
                                        placeholder="Enter Shop Email"
                                        disable={!isEditing}
                                        required
                                    />
                                </div>
                            </div>
                            {
                                isEditing ?

                                    <div className="flex flex-row max-h-12 gap-4">
                                        <Button
                                            type="submit"
                                            className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Loading..." : "Save"}
                                        </Button>
                                        <Button
                                            className="text-black bg-secondary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            disabled={isSubmitting}
                                            onClick={() => handleEditing(false)}
                                        >
                                            {"Cancel"}
                                        </Button>
                                    </div> :
                                    <div>
                                        <Button
                                            className="text-white bg-slate-800 hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-5 py-2.5 text-center"
                                            onClick={() => handleEditing(true)}
                                        >
                                            {"Edit"}
                                        </Button>
                                    </div>
                            }
                        </div>
                    </div>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 w-full mt-4">
                        {images.map((img) => (
                            <div key={img.id} className="w-48 h-48">
                                <ImagePicker
                                    preloadedImage={img.file}
                                    placeholder={"Upload Image"}
                                    onImageSelect={(file) => handleImageSelect(img.id, file)}
                                    disabled={!isEditing}
                                />
                            </div>
                        ))}
                        {isEditing && (
                            <button
                                type="button"
                                onClick={handleAddImage}
                                className="w-48 h-48 border-2 border-dashed flex items-center justify-center text-gray-500 hover:bg-gray-100"
                            >
                                + Add Image
                            </button>
                        )}
                    </div>
                </Form>
            )}
        </Formik>
    );
}

export default StoreDetailsView;
